import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagAL = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#000",
  d: "M39.13 18.555h-9.055A3.26 3.26 0 1 0 25 14.502a3.26 3.26 0 1 0-5.075 4.053H10.87c0 2.4 2.091 4.347 4.492 4.347h-.145a4.348 4.348 0 0 0 4.348 4.348c0 .778.205 1.507.563 2.138l-3.606 3.607 2.767 2.767 3.925-3.925c.153.056.312.101.477.132l-2.372 5.355L25 41.304l3.681-3.98-2.372-5.355c.165-.03.324-.076.477-.132l3.925 3.924 2.767-2.766-3.606-3.607a4.32 4.32 0 0 0 .563-2.138 4.348 4.348 0 0 0 4.348-4.348h-.145c2.4 0 4.492-1.946 4.492-4.347Z"
}));
FlagAL.displayName = 'FlagAL';
export default withFlagWrapper(FlagAL);
//# sourceMappingURL=index.js.map